import { extendTheme } from '@mui/joy/styles';

const theme = extendTheme({
	cssVarPrefix: 'and',
	colorSchemes: {
		light: {
			palette: {
				text: {
					primary: '#969696',
					secondary: '#545454',
					tertiary: '#CCCCCC',
				},
				primary: {
					50: '#FFFFFF',
					100: '#CFCFCF',
					200: '#BCE2DD',
					300: '#9CD5CF',
					400: '#9CD5CF',
					500: '#50BFB4',
					600: '#67A39D',
					700: '#648280',
					800: '#4D6A68',
					900: '#3A4F4F',
					solidBg: '#50BFB4',
					solidHoverBg: '#67A39D',
					solidActiveBg: '#50BFB4',
					solidActiveBorder: '#67A39D',
					solidDisabledBg: '#9CD5CF',
					outlinedColor: '#50BFB4',
					outlinedBorder: '#50BFB4',
					outlinedHoverBorder: undefined,
					outlinedHoverBg: '#50BFB4',
					outlinedHoverColor: '#FFFFFF',
					outlinedActiveBg: '#67A39D',
				},
				secondary: {
					500: '#6F5AA2',
				},
				neutral: {
					outlinedDisabledColor: '#b9b9b9',
				},
			},
		},
	},
	focus: {
		default: {
			outlineWidth: '3px',
		},
	},
	fontFamily: {
		display: 'Roboto, var(--and-fontFamily-fallback)',
		body: 'Roboto, var(--and-fontFamily-fallback)',
		h2: 'Inter, var(--and-fontFamily-fallback)',
		h3: 'Inter, var(--and-fontFamily-fallback)',
		h4: 'Inter, var(--and-fontFamily-fallback)',
	},
	typography: {
		display1: {
			fontSize: '5rem',
			background: 'linear-gradient(58deg,rgb(139, 135, 254) 0%, rgb(79, 182, 149) 50%, rgb(255, 243, 15) 100%)',
			backgroundClip: 'text',
			color: 'transparent',
			lineHeight: '4rem',
			paddingBottom: '2rem',
		},
		h1: {
			fontSize: '3.2rem',
			color: 'var(--and-palette-secondary-500)',
			lineHeight: '3rem',
			paddingBottom: '2rem',
		},
		h2: {
			color: '#545454',
		},
		body1: {
			lineHeight: '140%',
			fontSize: '1.3rem',
		},
		body3: {
			lineHeight: '140%',
			fontSize: '1.3rem',
			color: '#000000'
		},
	},
	components: {
		JoyTypography: {
			styleOverrides: {
				root: ({ theme, ownerState }) => ({
					...(ownerState.variant === 'jumbo' && {
						...theme.typography.h1,
						fontSize: '5rem',
						lineHeight: '5rem',
						padding: '3rem',
						textAlign: 'center',
					}),
				}),
			},
		},
		JoyModalDialog: {
			styleOverrides: {
				root: () => ({
					maxWidth: '40vw',
					padding: '30px',
				}),
			},
		},
		JoyButton: {
			styleOverrides: {
				root: ({ ownerState }) => ({
					borderRadius: '2rem',
					fontWeight: 600,
					...(ownerState.size === 'sm' && {
						fontSize: '0.8rem',
						paddingInline: '0.8rem',
					}),
					...(ownerState.size === 'md' && {
						minHeight: '2.5rem',
						fontSize: '1rem',
						paddingInline: '1rem',
					}),
				}),
			},
		},
		JoyInput: {
			styleOverrides: {
				root: ({ ownerState }) => ({
					...(ownerState.variant === 'hero' && {
						boxShadow: '0px 0px 75px rgba(24, 24, 24, 0.2)',
						fontSize: '1.2rem',
					}),
				}),
			},
		},
	},
});

export default theme;
